var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Container, FormGroup, Input, Form, Card, CardFooter, CardBody, Row, Col } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import Signals from '../../../signals/Signals';
import { ApplicationContext } from '../../../ApplicationContext';
import Session from '../../../services/Session';
import CardTitleHeader from '../../components/ui/Cards/CardTitleHeader';
import FormField from '../../components/ui/FormField/FormField';
import { FormErrorContext } from '../../../FormErrorContext';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import CloseServiceEntryRetroactivelyCommand from '../../../commands/services/CloseServiceEntryRetroactivelyCommand';
import DateInput from '../../components/ui/DateInput/DateInput';
import AssetMetaData from '../../components/ui/AssetMetaData/AssetMetaData';
import BasicFormGroup from "../../components/ui/BasicFormGroup/BasicFormGroup";
import Switch from "../../components/ui/Switch/Switch";
import ManualAssetModel from "../../../models/ManualAssetModel";
import UpdateManualAssetDataCommand from "../../../commands/assets/UpdateManualAssetDataCommand";
/**
 *
 */
var CloseServiceEntryOverlay = /** @class */ (function (_super) {
    __extends(CloseServiceEntryOverlay, _super);
    /**
     *
     * @param props
     */
    function CloseServiceEntryOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: [],
            submitting: false,
            resolution: null,
            closedDate: new Date()
        };
        _this.onClosedDateChange = _this.onClosedDateChange.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onCancel = _this.onCancel.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        return _this;
    }
    /**
     *
     */
    CloseServiceEntryOverlay.prototype.componentDidMount = function () {
        var serviceEntryModel = this.props.serviceEntryModel;
        var assetCollection = this.context.assetCollection;
        var assetModel = assetCollection.list.find(function (asset) { return asset.getAssetSerial() === serviceEntryModel.assetId; });
        this.setState({
            assetValueOnClose: assetModel ? Math.floor(assetModel.cumulativeOperatingHoursDurationInHours) : null
        });
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    CloseServiceEntryOverlay.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     */
    CloseServiceEntryOverlay.prototype.render = function () {
        var _this = this;
        var assetCollection = this.context.assetCollection;
        var _a = this.props, className = _a.className, intl = _a.intl, serviceEntryModel = _a.serviceEntryModel;
        var _b = this.state, errors = _b.errors, resolution = _b.resolution, closedDate = _b.closedDate, assetValueOnClose = _b.assetValueOnClose, updateManualAssetValue = _b.updateManualAssetValue;
        var assetModel = assetCollection.list.find(function (asset) { return asset.getAssetSerial() === serviceEntryModel.assetId; });
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return React.createElement(Container, { className: 'close-service-entry-overlay w-100 ' + className },
            React.createElement(FormErrorContext.Provider, { value: { errors: errors } },
                React.createElement(Form, { onChange: this.onInputChange, onSubmit: this.onSubmit },
                    React.createElement(Card, { className: "bg-white" },
                        React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'service.entry.close.overlay.title' }, serviceEntryModel) }),
                        React.createElement(CardBody, null,
                            React.createElement(Row, { className: "text-muted mb-3" },
                                React.createElement(Col, null,
                                    React.createElement(AssetMetaData, { serviceEntryModel: serviceEntryModel }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { sm: 12 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Row, null,
                                            React.createElement(Col, null,
                                                React.createElement("label", { htmlFor: "resolution" },
                                                    React.createElement(FormattedMessage, { id: "service.entry.close.overlay.field.resolution" })))),
                                        React.createElement(FormField, null,
                                            React.createElement("textarea", { className: "form-control", id: "resolution", name: "resolution", required: true }, resolution)))),
                                React.createElement(Col, { sm: 12, md: 6 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Row, null,
                                            React.createElement(Col, null,
                                                React.createElement("label", { htmlFor: "scheduleDate" },
                                                    React.createElement(FormattedMessage, { id: "service.entry.close.overlay.field.closedate" })))),
                                        React.createElement(FormField, null,
                                            React.createElement("div", { className: "input-group", "data-errorHandler": "closedDate" },
                                                React.createElement(DateInput, { intl: intl, id: "closedDate", name: "closedDate", className: "w-100", onBlur: this.onClosedDateChange, onChange: this.onClosedDateChange, value: closedDate ? closedDate : null, openToDate: closedDate ? closedDate : null, required: true }),
                                                React.createElement("div", { className: "input-group-append" },
                                                    React.createElement("span", { className: "input-group-text" },
                                                        React.createElement("i", { className: "fe fe-calendar" }))))))),
                                React.createElement(Col, { sm: 12, md: 6 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Row, null,
                                            React.createElement(Col, null,
                                                React.createElement("label", { htmlFor: "assetValueOnClose" },
                                                    React.createElement(FormattedMessage, { id: "service.entry.close.overlay.field.assetvalueonclose" })))),
                                        React.createElement(FormField, null,
                                            React.createElement("div", { className: "input-group", "data-errorHandler": "assetValueOnClose" },
                                                React.createElement(Input, { className: "flex-grow-1 flex-shrink-1", id: "assetValueOnClose", type: "number", min: 0, step: 1, name: "assetValueOnClose", autoComplete: "off", value: assetValueOnClose, required: true })))),
                                    assetModel && assetModel.isManualAsset &&
                                        React.createElement(BasicFormGroup, null,
                                            React.createElement(Switch, { id: "manualAssetValue", checked: updateManualAssetValue, onChange: function () {
                                                    _this.setState({ updateManualAssetValue: !updateManualAssetValue });
                                                } },
                                                React.createElement(FormattedMessage, { id: "service.entry.close.overlay.updatemanualasset" })))))),
                        React.createElement(CardFooter, null,
                            React.createElement("div", { className: "d-flex justify-content-end" },
                                React.createElement("button", { className: "btn btn-outline-primary mr-3", type: "button", onClick: this.onCancel },
                                    React.createElement(FormattedMessage, { id: "page.labels.cancel" })),
                                React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                    React.createElement(FormattedMessage, { id: "service.entry.close.overlay.submit" }))))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    /**
     *
     */
    CloseServiceEntryOverlay.prototype.onClosedDateChange = function (e, date) {
        if (date && !isNaN(date.getTime())) {
            this.setState({ closedDate: date });
        }
    };
    /**
     *
     * @param event
     */
    CloseServiceEntryOverlay.prototype.onInputChange = function (event) {
        var newState = {};
        switch (event.target.name) {
            case 'closedDate':
                //Handled by onClosedDateChange
                break;
            default:
                newState[event.target.name] = event.target.value;
        }
        this.setState(newState);
    };
    /**
     *
     * @param event
     */
    CloseServiceEntryOverlay.prototype.onSubmit = function (event) {
        event.preventDefault();
        var _a = this.context, session = _a.session, serviceEntryCollection = _a.serviceEntryCollection;
        var _b = this.props, serviceEntryModel = _b.serviceEntryModel, intl = _b.intl;
        var _c = this.state, resolution = _c.resolution, closedDate = _c.closedDate, assetValueOnClose = _c.assetValueOnClose;
        if (!serviceEntryModel) {
            return;
        }
        var data = {
            resolution: resolution,
            closedDateTimestamp: closedDate ? closedDate.getTime() : null,
            assetValueOnClose: parseInt('' + assetValueOnClose)
        };
        var command = new CloseServiceEntryRetroactivelyCommand();
        command.execute(data, session.user.organisation, serviceEntryModel, serviceEntryCollection, intl)
            .then(this.onSuccess)
            .catch(this.onError);
    };
    /**
     *
     */
    CloseServiceEntryOverlay.prototype.onCancel = function () {
        Signals.HideOverlay.dispatch();
    };
    /**
     *
     */
    CloseServiceEntryOverlay.prototype.onSuccess = function () {
        var _this = this;
        var assetCollection = this.context.assetCollection;
        var _a = this.props, serviceEntryModel = _a.serviceEntryModel, intl = _a.intl;
        var _b = this.state, assetValueOnClose = _b.assetValueOnClose, closedDate = _b.closedDate;
        var assetModel = assetCollection.list.find(function (asset) { return asset.getAssetSerial() === serviceEntryModel.assetId; });
        // Remove serviceEntry from assetModel
        assetModel.serviceEntries = assetModel.serviceEntries.filter(function (serviceEntry) { return serviceEntry.serviceEntryId !== serviceEntryModel.serviceEntryId; });
        // Update manual asset value
        if (this.state.updateManualAssetValue) {
            try {
                var manualAssetModel_1 = new ManualAssetModel();
                manualAssetModel_1.updateFromAssetModel(assetModel);
                if (manualAssetModel_1.cumulativeOperatingHoursValue.value !== null) {
                    manualAssetModel_1.cumulativeOperatingHoursValue.value = parseInt('' + assetValueOnClose);
                    manualAssetModel_1.cumulativeOperatingHoursValue.timestamp = closedDate ? closedDate.getTime() : (new Date()).getTime();
                }
                if (!(manualAssetModel_1.fuelUsedInLiters.timestamp == null || manualAssetModel_1.fuelUsedInLiters.value == null)) {
                    manualAssetModel_1.fuelUsedInLiters.timestamp = new Date(manualAssetModel_1.fuelUsedInLiters.timestamp).getTime();
                }
                if (!(manualAssetModel_1.location.latitude == null || manualAssetModel_1.location.longitude == null || manualAssetModel_1.location.timestamp == null)) {
                    manualAssetModel_1.location.timestamp = new Date(manualAssetModel_1.location.timestamp).getTime();
                }
                //
                var command = new UpdateManualAssetDataCommand();
                command.execute(manualAssetModel_1, Session.user.organisation.id, intl).then(function () {
                    // Update asset model to keep views in sync
                    assetModel.properties.cumulativeOperatingHoursDateTimeUtc = closedDate;
                    assetModel.properties.cumulativeOperatingHoursDurationInHours = manualAssetModel_1.cumulativeOperatingHoursValue.value;
                    _this.onSubmitComplete();
                }).catch(this.onError);
            }
            catch (error) {
                console.log(error);
            }
        }
        else {
            this.onSubmitComplete();
        }
    };
    /**
     *
     */
    CloseServiceEntryOverlay.prototype.onSubmitComplete = function () {
        this.setState({ errors: null, submitting: false });
        Signals.HideOverlay.dispatch();
        Signals.HideAssetDetail.dispatch();
    };
    /**
     *
     * @param error
     */
    CloseServiceEntryOverlay.prototype.onError = function (error) {
        console.log('onError.', error);
        this.setState({ submitting: false });
        // Convert errors
        try {
            var errors = error.error.response.body.errors;
            var errorKeys = Object.keys(errors);
            errorKeys.forEach(function (key) {
                if (key.indexOf('ServiceEntryCannotCloseGivenAssetValueLtAssetValueOnCreation') > 0) {
                    error.error.response.body.errors[key] = null;
                    error.error.response.body.errors['assetValueOnClose'] = ['serviceentry.error.serviceentrycannotclosegivenassetvalueltassetvalueoncreation'];
                }
            });
        }
        catch (e) { }
        createErrorResponse(this, error);
    };
    CloseServiceEntryOverlay.defaultProps = {
        className: ''
    };
    CloseServiceEntryOverlay = __decorate([
        observer
    ], CloseServiceEntryOverlay);
    return CloseServiceEntryOverlay;
}(React.Component));
CloseServiceEntryOverlay.contextType = ApplicationContext;
CloseServiceEntryOverlay.defaultProps = {
    className: ''
};
export default injectIntl(CloseServiceEntryOverlay);
